import type {AvailableFilters} from '@lib/components/ui/custom/data-table/types';
import type {ColumnFilter, ColumnFiltersState} from '@tanstack/react-table';
import type {Operator} from '@lib/types/table-operators';
import type {Dispatch, FC, SetStateAction} from 'react';

export const FilterTypes = {
  Text: `text`,
  Date: `date`,
  Number: `number`,
  Boolean: `boolean`,
  MultiSelect: `multiselect`,
  Custom: `custom`,
  NextMultiSelect: `next-multiselect`,
} as const;

type ValuesOf<T> = T[keyof T];
export type FilterType = ValuesOf<typeof FilterTypes>;

export type FilterValueWithOperator = {
  value: string | number;
  operator?: Operator;
};

export interface ColumnFilterWithOperator extends ColumnFilter {
  id: string;
  value: FilterValueWithOperator;
}

export type ColumnFiltersWithOperator = Array<ColumnFilterWithOperator>;
export type ConditionFiltersWithOperator = Array<ColumnFilterWithOperator & {condition_type: string}>;

export type SetColumnFilters =
  | Dispatch<SetStateAction<ColumnFiltersState | ColumnFiltersWithOperator>>
  | ((columnFilters: ColumnFiltersState | ColumnFiltersWithOperator) => void);

export type LegacyFiltersCustomComponent = FC<{
  value: unknown;
  onChange: (value: unknown, extra?: Record<string, any>) => void;
  onApply?: (extra?: Record<string, any>) => void;
  onCancel?: () => void;
  extra?: Record<string, any>;
  context?: Record<string, any> & {selectedFilter?: ColumnFilterWithOperator | null};
}>;

export type FilterMultiSelect = Record<string, any>;

export type FilterFunction = (value: FilterValueWithOperator, ...rest: Array<string>) => Record<string, any>;

export type EndpointFilters = Record<string, AvailableFilters>;
